module.exports = __webpack_public_path__ + "img/document-img.513724a2.svg";